export default function () {
  return {
    salesData: []
  }
}
